import React from 'react';
import { Card } from 'react-bootstrap';

// import { Container } from './styles';

interface CardTProps {
  title: string;
  footer?: React.ReactNode;
}
const CardCadastro: React.FC<CardTProps> = ({ title, children, footer }) => {
  return (
    <>
      <Card style={{ minHeight: '115px' }}>
        <Card.Header as="h5" className="text-center p-1 small">
          <b>{title}</b>
        </Card.Header>
        <Card.Body>
          <Card.Text className="text-center small">{children}</Card.Text>
        </Card.Body>
        <Card.Footer>{footer}</Card.Footer>
      </Card>
    </>
  );
};

export default CardCadastro;
